import { readable } from 'svelte/store';
import jwt_decode from 'jwt-decode';
import 'svelte/internal';
const QOTTENAUTH_API_URL = 'https://authentication.qotto.net/api';
const QOTTENAUTH_ISSUER = 'qotto';
const AUTH_COOKIE_NAME = 'auth-token';
const APP_NAME = 'dashboard';
class NoAuthCookieError extends Error {
    constructor(...params) {
        super(...params);
        this.name = this.constructor.name;
    }
}
class NotLoggedInError extends Error {
    constructor(...params) {
        super(...params);
        this.name = this.constructor.name;
    }
}
class NotAuthorizedError extends Error {
    constructor(...params) {
        super(...params);
        this.name = this.constructor.name;
    }
}
class TechnicalLoginError extends Error {
    constructor(...params) {
        super(...params);
        this.name = this.constructor.name;
    }
}
async function get_auth_token() {
    console.info("Getting auth token…");
    const rows = document.cookie.split('; ');
    const row = rows.find(r => r.startsWith(`${AUTH_COOKIE_NAME}=`));
    if (!row) {
        throw new NoAuthCookieError();
    }
    const auth_token = row.split('=')[1];
    console.debug("Got auth token:", auth_token);
    return auth_token;
}
async function get_user_info() {
    console.info("Getting auth claims…");
    try {
        const auth_token = await get_auth_token();
        const jwt_claims = jwt_decode(auth_token);
        console.debug("Got auth claims:", jwt_claims);
        if (!jwt_claims.apps.includes(APP_NAME)) {
            throw new NotAuthorizedError();
        }
        const current_date = new Date().getTime() / 1000;
        if (jwt_claims.exp && jwt_claims.exp < current_date) {
            console.warn("The JWT auth token is expired.");
            throw new NotLoggedInError();
        }
        if (jwt_claims.nbf && jwt_claims.nbf > current_date) {
            console.warn("The JWT auth token is not valid yet.");
            throw new NotLoggedInError();
        }
        if (jwt_claims.iat && jwt_claims.iat > current_date) {
            console.warn("The JWT auth token is issued in the future. Check your computer time.");
            throw new TechnicalLoginError("Your computer time might be wrong.");
        }
        if (jwt_claims.iss != QOTTENAUTH_ISSUER) {
            console.warn("The JWT auth token has a non-trusted issuer.");
            throw new TechnicalLoginError("Authentication token issuer is invalid.");
        }
        return {
            'uuid': jwt_claims.sub,
            'name': jwt_claims.metadata.displayed_name,
            'gender': jwt_claims.metadata.gender,
        };
    }
    catch (e) {
        if (e instanceof NoAuthCookieError) {
            console.warn("No auth cookie found.");
            throw new NotLoggedInError();
        }
        else {
            throw e;
        }
    }
}
export const user_info = readable({}, function start(set) {
    get_user_info().then(user_info => {
        set(user_info);
    }).catch(e => {
        set(null);
    });
    return function stop() {
        return;
    };
});
